/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
//import Footer from "components/Footer/Footer.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2022/04/website-traffic-prediction/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2022/04/website-traffic-prediction/SectionBlogInfo.js";


import blogPostPageStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostPageStyle.js";

const useStyles = makeStyles(blogPostPageStyle);

export const metadata = {
  title: "How to predict website traffic in 4 steps",
  date: "2022-04-22",
  summary: "We are an Australian Digital Marketing Agency based in Melbourne. We can help you with your GTM setup! We made website traffic prediction models (suitable for smaller websites) in Python and placed output to Data Studio for live monitoring. Read this article for more information.",
  image: "/img/posts/2022-04-22-website-traffic-prediction/MultipleModels.png",
  url: "https://www.tribalism.com.au/blog-post/2022/04/website-traffic-prediction",
  author: "Robert Dzudzar",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="How to predict website traffic in 4 steps"
        image="/img/posts/2022-04-22-website-traffic-prediction/MultipleModels.png"
        url="https://www.tribalism.com.au/blog-post/2022/04/website-traffic-prediction"
        type="article"
        description="We are an Australian Digital Marketing Agency based in Melbourne. We can help you with your GTM setup!"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2022-04-22-website-traffic-prediction/MultipleModels.png" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              How to predict website traffic in 4 steps
              </h1>
              <h4 className={classes.subtitle}>

              We made website traffic prediction models (suitable for smaller websites) in Python and placed output to Data Studio for live monitoring. 
              Read this article for more information.

              <br></br>
              <br></br>
              Posted by: Robert Dzudzar


              </h4>
              <br />
              <Button color="warning" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />

        </div>
      </div>



      <Footer
       
      />
    </div>
  );
}
